import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappNumber = '917310630006';
  const message = 'Hello! I would like to inquire about luxury travel experiences.';

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="whatsapp-float w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-xl"
      data-testid="whatsapp-float-button"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={28} />
    </button>
  );
};

export default WhatsAppButton;